import React, {SyntheticEvent} from 'react'
import {Link} from 'react-router-dom'
import './ServiceRequestChoiceCard.scss'
import {CardTitle} from '../../../genericComponents/typographie/CardTitle'
import {Description} from '../../../genericComponents/typographie/Description'
import {InfoTooltip} from '../../../genericComponents/customInfoToolTip/InfoTooltip'

export interface Disabled {
    isDisabled: boolean
    reason: string
}

export const ServiceRequestChoiceCard = ({
    icon,
    title,
    description,
    id,
    to,
    disabled
}: {
    icon?: React.ReactNode
    title?: string
    description?: string
    to: string
    id: string
    disabled?: Disabled
}) => {
    const onClick = (event: SyntheticEvent) => {
        if (disabled?.isDisabled) event.preventDefault()
    }

    return (
        <Link
            to={to}
            className={`service-request-choice-card ${disabled?.isDisabled ? 'isDisabled' : ''}`}
            data-testid={id}
            id={id}
            onClick={onClick}
        >
            <div className="icon-container">
                {icon && <div className="card-icon">{icon}</div>}
                {disabled?.isDisabled && (
                    <InfoTooltip title={disabled?.reason} />
                )}
            </div>
            {title && <CardTitle title={title}>{title}</CardTitle>}
            {description && <Description className="card-description">{description}</Description>}
        </Link>
    )
}
